import { END_POINTS } from '@/api/end-points'
import fetch from '../fetch-with-authorization'

export const createLinkToken = async (itemId, authOnly = false) =>
  fetch({
    path: itemId 
      ? `${END_POINTS.PAYMENT.PLAID.CREATE_LINK_TOKEN}?itemId=${itemId}&authOnly=${authOnly}`
      : `${END_POINTS.PAYMENT.PLAID.CREATE_LINK_TOKEN}?authOnly=${authOnly}`,
  })

export const exchangePublicToken = async ({ publicToken, payload, monitor = false }) =>
  fetch({
    path: END_POINTS.PAYMENT.PLAID.EXCHANGE_PUBLIC_TOKEN,
    method: 'POST',
    body: JSON.stringify({ publicToken, payload, monitor, version: 2 }),
  })

export const getPlaidItems = async () => {
  const data = await fetch({
    path: END_POINTS.PAYMENT.PLAID.GET_PLAID_ITEMS,
  })
  return data
}

export const syncPlaidItems = async () => {
  const data = await fetch({
    path: END_POINTS.PAYMENT.PLAID.SYNC_PLAID_ITEMS,
    method: 'POST',
  })
  return data
}

export const deletePlaidItem = async ({ plaidItemId }) =>{
  const data = await fetch({
    path: END_POINTS.PAYMENT.PLAID.DELETE_PLAID_ITEM + `${plaidItemId}`,
    method: 'DELETE',
  })
  return data
}

